/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditSingleRemainedQuotaApiRequest } from '../../models/hotel-edit-single-remained-quota-api-request';

export interface ApiHotelManageEditSingleRemainedQuotaPost$Params {
      body: HotelEditSingleRemainedQuotaApiRequest
}

export function apiHotelManageEditSingleRemainedQuotaPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditSingleRemainedQuotaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditSingleRemainedQuotaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditSingleRemainedQuotaPost.PATH = '/api/hotel/manage/edit/single/remained-quota';
